import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

export const acquireAccessToken = async (
  theInstance: IPublicClientApplication,
  theAccount: AccountInfo,
  theScopes: string[]
) => {
  const accessTokenRequest = {
    scopes: theScopes,
    account: theAccount,
  };

  const result = await theInstance.acquireTokenSilent(accessTokenRequest);

  return result;
};
